export class DecarbonizationType {

  public id: string;
  public label: string;

}

export class DecarbonizationTypeRegion extends DecarbonizationType {

  public regionId: string;

}
